import React from "react";

import { AgeBandedGenderRate } from "../../constants/aquafina";
import { CoverageArrowRow, CoverageRow } from "../table/rows";
import { CoverageCell, CoverageHeaderCell } from "../table/cells";
import { RangeIterator } from "../../utils";

const AgeBandedGenderRates = ({ rates }: { rates: AgeBandedGenderRate[] }) => {
  const tiersMale = new Map<string, string[]>();
  const tiersFemale = new Map<string, string[]>();
  RangeIterator(rates.length, (index) => {
    rates[index]?.male?.tiers?.forEach((tier) => {
      const tierName = tier.name;
      if (!tierName) return;
      if (!tiersMale.has(tierName)) {
        tiersMale.set(tierName, new Array(rates.length).fill(""));
      }
      (tiersMale.get(tierName) as string[])[index] = tier.value;
    });
    rates[index].female.tiers.forEach((tier) => {
      const tierName = tier.name;
      if (!tierName) return;
      if (!tiersFemale.has(tierName)) {
        tiersFemale.set(tierName, new Array(rates.length).fill(""));
      }
      (tiersFemale.get(tierName) as string[])[index] = tier.value;
    });
  });
  return (
    <>
      <CoverageRow label="Rate Unit">
        {RangeIterator(rates.length, (index) => (
          <CoverageCell value={rates[index].rateUnit} key={index} />
        ))}
      </CoverageRow>
      <CoverageRow label="Rates" isWhite>
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageRow>
      <CoverageArrowRow label="Male">
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageArrowRow>
      {Array.from(tiersMale.entries()).map(([label, values], indexTier) => (
        <CoverageArrowRow
          key={label}
          label={label}
          level={2}
          isWhite={indexTier % 2 === 0}
        >
          {values.map((value, index) => (
            <CoverageCell value={value} key={index} />
          ))}
        </CoverageArrowRow>
      ))}
      <CoverageArrowRow
        label="Female"
        isWhite={(4 + Array.from(tiersMale.entries()).length) % 2 === 0}
      >
        {RangeIterator(rates.length, (index) => (
          <CoverageHeaderCell label={""} key={index} />
        ))}
      </CoverageArrowRow>
      {Array.from(tiersFemale.entries()).map(([label, values], indexTier) => (
        <CoverageArrowRow
          key={label}
          label={label}
          level={2}
          isWhite={
            (4 + Array.from(tiersMale.entries()).length + indexTier) % 2 !== 0
          }
        >
          {values.map((value, index) => (
            <CoverageCell value={value} key={index} />
          ))}
        </CoverageArrowRow>
      ))}
    </>
  );
};

export default AgeBandedGenderRates;
